import { PureComponent } from 'react'
class ProgressBar extends PureComponent {
    render() {
        return null
    }
}
export default ProgressBar
